package org.wordsapp.data

import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json
import org.wordsapp.getBaseUrl
import org.wordsapp.model.*

class ApiClient(baseUrl: String = getBaseUrl()) {
    private val url = baseUrl

    private val client = createPlatformHttpClient {
        install(ContentNegotiation) {
            json(Json { ignoreUnknownKeys = true })
        }
    }

    fun getLoginUrl(): String = "$url/auth/login"

    suspend fun getAuthStatus(): AuthStatusResponse {
        return client.get("$url/auth/status").body()
    }

    suspend fun exchangeAppSessionToken(token: String): AuthStatusResponse {
        return client.post("$url/auth/app-session") {
            contentType(ContentType.Application.Json)
            setBody(AppSessionRequest(token))
        }.body()
    }

    suspend fun getWords(): WordsResponse {
        return client.get("$url/api/words").body()
    }

    suspend fun updateStats(rowIndex: Int, request: UpdateStatsRequest): UpdateStatsResponse {
        return client.put("$url/api/words/$rowIndex/stats") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()
    }

    suspend fun getSettings(): SettingsResponse {
        return client.get("$url/api/settings").body()
    }

    suspend fun saveSettings(request: SettingsRequest): SettingsResponse {
        return client.post("$url/api/settings") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()
    }

    suspend fun logout() {
        client.post("$url/auth/logout")
    }
}
